<template>
    <Card>
        <div class="content-download__list">
            <content-download
                v-for="file in content.files"
                :key="file.id"
                :file="file"
                :content="content"
                class="content-download__item"
            ></content-download>
        </div>
    </Card>
</template>

<script>
import Card from '../../../../argon/components/Cards/Card';
import ContentDownload from '../../../../components/LessonContentComponents/LessonContentUpload/ContentDownload';

export default {
    name: 'OptionsSupportMaterial',
    props: {
        content: Object,
    },
    components: {
        Card,
        ContentDownload,
    },
    data() {
        return {
            action: 'generate',
            hash: 'cf278b2b38837773454d424890e401915d8bd39f253f6',
            response: false,
            status: 'none',
            downloadUrl: false,
            file: {},
        };
    },
};
</script>

<style scoped>
    .content-download__item {
        border-top: 1px solid #ccc;
        padding: 15px 0;
    }

    .content-download__list :first-child {
        border-top: none !important;
    }
</style>
